import { Rocket, Zap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PLAN_CONFIG = {
  free: { label: 'Nieaktywny', bg: 'bg-zinc-100', text: 'text-zinc-500', border: 'border-zinc-200' },
  diy: { label: 'System aktywny', bg: 'bg-emerald-50', text: 'text-emerald-600', border: 'border-emerald-200', icon: Zap },
  done_for_you: { label: 'System aktywny', bg: 'bg-[#F47A3B]/10', text: 'text-[#F47A3B]', border: 'border-[#F47A3B]/30', icon: Rocket },
  pro: { label: 'PRO', bg: 'bg-[#F7931E]/10', text: 'text-[#F7931E]', border: 'border-[#F7931E]/30', icon: Zap },
  premium: { label: 'PREMIUM', bg: 'bg-purple-100', text: 'text-purple-700', border: 'border-purple-200', icon: Rocket },
};

export default function PlanBadge({ plan = 'free' }) {
  const navigate = useNavigate();
  const config = PLAN_CONFIG[plan] || PLAN_CONFIG.free;
  const Icon = config.icon;

  return (
    <button
      onClick={() => navigate('/panel/subskrypcja')}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-bold tracking-wide border ${config.bg} ${config.text} ${config.border} hover:opacity-80 transition-opacity`}
      data-testid="plan-badge"
    >
      {Icon && <Icon className="w-3 h-3" />}
      {config.label}
    </button>
  );
}
